import MainContent from '@/components/layout/MainContent.vue'
import { _, isAuthorized, piloteAndAuditor } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

import { dashboardsRoutes } from '@/contexts/dashboards/Dashboards.routes'
import { perimetersRoutes } from '@/contexts/perimeters/Perimeters.routes'

export const performanceRoutes: RouteConfig = {
  path: '/org2',
  name: 'organization2',
  component: MainContent,
  meta: {
    title: _('Performance'),
    dummy: true,
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    is_authorized: (route: Route) => isAuthorized(route),
  },
  children: [perimetersRoutes, dashboardsRoutes],
}
